"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

exports.FULL_DECIMALS = new contract_wrappers_1.BigNumber(18);
exports.ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';